import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
// Import the centralized functions instead of axios
import { fetchRideById, updateRide } from "../utils/api"; 
import "../css/postcard.css";

export default function EditRidePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("travelo_token");

  const [form, setForm] = useState({
    date: "",
    time: "",
    seatsAvailable: 0,
    pricePerSeat: 0,
    description: "",
    status: "pending",
  });
  const [loading, setLoading] = useState(true);

  // Load ride details using the utility function
  useEffect(() => {
    const loadRideData = async () => {
      try {
        if (!token) return;
        const ride = await fetchRideById(id, token);
        
        setForm({
          date: ride.date ? new Date(ride.date).toISOString().slice(0, 10) : "",
          time: ride.time || "",
          seatsAvailable: ride.seatsAvailable || 0,
          pricePerSeat: ride.pricePerSeat || 0,
          description: ride.description || "",
          status: ride.status || "pending",
        });
      } catch (err) {
        console.error("Error loading ride:", err);
      } finally {
        setLoading(false);
      }
    };

    loadRideData();
  }, [id, token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Submit using the utility function
  const handleSubmit = async () => {
    try {
      await updateRide(id, form, token);
      alert("✅ Ride updated successfully!");
      navigate(`/ride/${id}`);
    } catch (err) {
      alert(err.response?.data?.error || "Failed to update ride");
    }
  };

  if (loading) return <div className="edit-loading">Loading ride details...</div>;

  return (
    <div className="edit-ride-page">
      <h2>✏️ Edit Ride</h2>

      <div className="form-grid">
        <div className="form-group">
          <label>📅 Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>⏰ Time</label>
          <input type="time" name="time" value={form.time} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>💺 Seats Available</label>
          <input type="number" name="seatsAvailable" value={form.seatsAvailable} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>💰 Price per Seat</label>
          <input type="number" name="pricePerSeat" value={form.pricePerSeat} onChange={handleChange} />
        </div>
      </div>

      <div className="form-group full-width">
        <label>📝 Description</label>
        <textarea name="description" value={form.description} onChange={handleChange}></textarea>
      </div>

      <div className="edit-actions">
        <button className="btn btn-primary" onClick={handleSubmit}>💾 Save Changes</button>
        <button className="btn btn-outline" onClick={() => navigate(-1)}>❌ Cancel</button>
      </div>
    </div>
  );
}